import { Skeleton } from "@/components/shared/Skeleton";
import type React from "react";

interface BreadcrumbSkeletonProps {
  itemsCount?: number;
  className?: string;
}

export const BreadcrumbSkeleton: React.FC<BreadcrumbSkeletonProps> = ({
  itemsCount = 3,
  className = "",
}) => {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex items-center space-x-2 text-sm">
        {Array.from({ length: itemsCount }).map((_, idx) => (
          <li key={`breadcrumb-item-${idx + 1}`} className="flex items-center">
            {idx > 0 && <Skeleton className="w-4 h-4 mx-2" />}

            <Skeleton className={`h-4 ${idx === itemsCount - 1 ? "w-20" : "w-16"}`} />
          </li>
        ))}
      </ol>
    </nav>
  );
};
